function initMusicPlayer() {
  const audioEl = document.getElementById("bg-audio");
  const playerEl = document.getElementById("music-player");
  const labelEl = document.getElementById("music-player-label");
  const barsEl = document.getElementById("music-player-bars");
  const iconEl = document.getElementById("music-icon");

  if (!audioEl || !playerEl) return;

  let isPlaying = false;
  let hasInteracted = false;

  const playIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="var(--gold)">
      <polygon points="8,6 18,12 8,18"/>
    </svg>
  `;

  const pauseIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="var(--gold)">
      <rect x="7" y="6" width="3" height="12"/>
      <rect x="14" y="6" width="3" height="12"/>
    </svg>
  `;

  iconEl.innerHTML = playIcon;
  playerEl.setAttribute("aria-pressed", "false");

  playerEl.addEventListener("click", togglePlayback);

  playerEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      togglePlayback();
    }
  });

  function togglePlayback() {
    if (!hasInteracted) {
      hasInteracted = true;
      setTimeout(() => {
        playerEl.classList.add("minimized");
      }, 4000);
    }

    isPlaying ? pauseMusic() : playMusic();
  }

  function playMusic() {
    audioEl
      .play()
      .then(() => {
        isPlaying = true;

        labelEl.textContent = "Pausar música";
        barsEl.classList.remove("paused");
        iconEl.innerHTML = pauseIcon;

        playerEl.classList.add("playing");

        playerEl.setAttribute("aria-pressed", "true");
      })
      .catch((e) => {
        console.error(e);
        labelEl.textContent = "Toca para reproducir";
      });
  }

  function pauseMusic() {
    audioEl.pause();
    isPlaying = false;

    labelEl.textContent = "Reproducir música";
    barsEl.classList.add("paused");
    iconEl.innerHTML = playIcon;

    playerEl.classList.remove("playing");

    playerEl.setAttribute("aria-pressed", "false");
  }

  setTimeout(() => {
    playerEl.classList.add("minimized");
  }, 10000);

  const unlockAudio = () => {
    if (!isPlaying) playMusic();
    document.removeEventListener("pointerdown", unlockAudio);
    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("keydown", unlockAudio);
    document.removeEventListener("touchstart", unlockAudio);
  };

  document.addEventListener("pointerdown", unlockAudio);
  document.addEventListener("click", unlockAudio);
  document.addEventListener("keydown", unlockAudio);
  document.addEventListener("touchstart", unlockAudio);
}
